import "./MicroNirPatu.module.css";
import Header from "@/reusable_sections/Header";
import MicroNirHero from "./sections/MicroNirHero";
import Applications from "./sections/Applications";
import RelatedSolutions from "./sections/RelatedSolutions";
import RelatedServices from "./sections/RelatedServices";
import DiscussCTA from "./sections/DiscussCTA";
import Footer from "@/reusable_sections/Footer";
export default function MicroNirPatuPage() {
  return <div>
      <Header />
      <MicroNirHero />
      <Applications />
      <RelatedSolutions />
      <RelatedServices />
      <DiscussCTA />
      <Footer />
    </div>;
}